export const isApiSupportedInBrowser = apiName => {
  return apiName in window;
};
